import { Button } from "../../utils/Utils";
import { GameVars } from "../../GameVars";
import { GameConstants } from "../../GameConstants";
import { GameManager } from "../../GameManager";
import * as Candy from "@ravalmatic/candy-engine";

export class GUIDevelopment extends Phaser.GameObjects.Container {

    private slowSpeedButton: Button;
    private normalSpeedButton: Button;

    constructor(scene: Phaser.Scene) {
        
        super(scene);

        const resetButton = new Button(this.scene, 50, GameConstants.GAME_HEIGHT - 60, "texture_atlas_0", "btn_reset_off", "btn_reset_on");
        resetButton.onDown(this.onClickResetGame, this);
        resetButton.setScale(.92, .92 * GameVars.scaleY);
        this.add(resetButton);

        const backButton = new Button(this.scene, 138, GameConstants.GAME_HEIGHT - 60, "texture_atlas_0", "btn_back_off", "btn_back_on");
        backButton.onDown(this.onClickBack, this);
        backButton.scaleY = GameVars.scaleY;
        backButton.setScale(1.125, 1.125 * GameVars.scaleY);
        this.add(backButton);

        const logButton = new Button(this.scene, 220, GameConstants.GAME_HEIGHT - 60, "texture_atlas_0", "btn_log_off", "btn_log_on");
        logButton.onDown(this.onClickLog, this);
        logButton.scaleY = GameVars.scaleY;
        logButton.setScale(.92, .92 * GameVars.scaleY);
        this.add(logButton);

        this.slowSpeedButton = new Button(this.scene, 306, GameConstants.GAME_HEIGHT - 60, "texture_atlas_0", "btn_slow_off", "btn_slow_on");
        this.slowSpeedButton.onDown(this.onClickSpeed, this);
        this.slowSpeedButton.setScale(.95, .95 * GameVars.scaleY);
        this.add(this.slowSpeedButton);

        this.normalSpeedButton = new Button(this.scene, 306, GameConstants.GAME_HEIGHT - 60, "texture_atlas_0", "btn_normal_off", "btn_normal_on");
        this.normalSpeedButton.onDown(this.onClickSpeed, this);
        this.normalSpeedButton.setScale(.95, .95 * GameVars.scaleY);
        this.normalSpeedButton.visible = false;
        this.add(this.normalSpeedButton);

        const stripedStripedButton = new Button(this.scene, 420, GameConstants.GAME_HEIGHT - 100, "texture_atlas_0", "btn_striped_striped_off", "btn_striped_striped_on");
        stripedStripedButton.onDown(this.onClickStripedStriped, this);
        stripedStripedButton.setScale(.92, .92 * GameVars.scaleY);
        this.add(stripedStripedButton);

        const wrappedStripedButton = new Button(this.scene, 555, GameConstants.GAME_HEIGHT - 100, "texture_atlas_0", "btn_wrapped_striped_off", "btn_wrapped_striped_on");
        wrappedStripedButton.onDown(this.onClickWrappedStriped, this);
        wrappedStripedButton.setScale(.92, .92 * GameVars.scaleY);
        this.add(wrappedStripedButton);

        const wrappedWrappedButton = new Button(this.scene, 690, GameConstants.GAME_HEIGHT - 100, "texture_atlas_0", "btn_wrapped_wrapped_off", "btn_wrapped_wrapped_on");
        wrappedWrappedButton.onDown(this.onClicWrappedWrapped, this);
        wrappedWrappedButton.setScale(.92, .92 * GameVars.scaleY);
        this.add(wrappedWrappedButton);

        const bombStripedButton = new Button(this.scene, 420, GameConstants.GAME_HEIGHT - 40, "texture_atlas_0", "btn_bomb_striped_off", "btn_bomb_striped_on");
        bombStripedButton.onDown(this.onClickBombStriped, this);
        bombStripedButton.setScale(.92, .92 * GameVars.scaleY);
        this.add(bombStripedButton);

        const bombWrappedButton = new Button(this.scene, 555, GameConstants.GAME_HEIGHT - 40, "texture_atlas_0", "btn_bomb_wrapped_off", "btn_bomb_wrapped_on");
        bombWrappedButton.onDown(this.onClickBombWrapped, this);
        bombWrappedButton.setScale(.92, .92 * GameVars.scaleY);
        this.add(bombWrappedButton);

        const bombBombButton = new Button(this.scene, 690, GameConstants.GAME_HEIGHT - 40, "texture_atlas_0", "btn_bomb_bomb_off", "btn_bomb_bomb_on");
        bombBombButton.onDown(this.onClickBombBomb, this);
        bombBombButton.setScale(.92, .92 * GameVars.scaleY);
        this.add(bombBombButton);
    }

    private onClickResetGame(): void {
        
        GameManager.resetGame();
    }

    private onClickBack(): void {
        
        GameManager.back();
    }

    private onClickLog(): void {
        
        GameManager.logBoard(true);
    }

    private onClickSpeed(): void {

        this.normalSpeedButton.visible = !this.normalSpeedButton.visible;
        this.slowSpeedButton.visible = !this.slowSpeedButton.visible;

        GameManager.toggleOrbsSpeed();
    }

    private onClickStripedStriped(): void {
        
        GameManager.enterBoardScene(Candy.Match.COMBO_STRIPED_STRIPED);
    }   

    private onClickWrappedStriped(): void {

        GameManager.enterBoardScene(Candy.Match.COMBO_WRAPPED_STRIPED);
    }

    private onClicWrappedWrapped(): void {
        
        GameManager.enterBoardScene(Candy.Match.COMBO_WRAPPED_WRAPPED);
    }

    private onClickBombStriped(): void {
        
        GameManager.enterBoardScene(Candy.Match.COMBO_BOMB_STRIPED);
    }

    private onClickBombWrapped(): void {
        
        GameManager.enterBoardScene(Candy.Match.COMBO_BOMB_WRAPPED);
    }

    private onClickBombBomb(): void {
        
        GameManager.enterBoardScene(Candy.Match.COMBO_BOMB_BOMB);
    }
}
